"use strict";

emailBlast.classy.controller({
    name: "EmailBlastController",
    inject: ["$scope", "$http", "$modal", "$state",
        "authServiceFactory", "SchoolSubcategoriesModelService", "FirstRunModalService", 
        "EmailBlastArchiveModelService", "EmailBlastRecipientsModelService", 
        "EmailBlastService", "SchoolModelService", 
        "recipients", "currentYear"],
    init: function()
    {
        this.FirstRunModalService.fireFirstRun("email");
        this.$.versionNo = versionNo;
        this.$.SchoolSubcategoriesModelService = this.SchoolSubcategoriesModelService;
        this.$.EmailBlastArchiveModelService = this.EmailBlastArchiveModelService;
        this.$.EmailBlastRecipientsModelService = this.EmailBlastRecipientsModelService;
        this.$.reviewOpen = false;
        this.$.EmailBlastService = this.EmailBlastService;
        this.$.schoolmodel = this.SchoolModelService;
        //this.$.recipients = this.EmailBlastRecipientsModelService.get();
        this.$.filters = {"bin":0, "tax":0, "nrChoice":0};

        this.$.bin = [
            {"code": "NEW", "name": "New", "selected": false},
            {"code": "VIE", "name": "Viewed", "selected": false},
            {"code": "CON", "name": "Considering", "selected": false},
            {"code": "AWA", "name": "Awarded", "selected": false},
            {"code": "REJ", "name": "Non-Awarded", "selected": false}
        ];
        this.$.status = [
            {"code": "TXN", "name": "Taxes not received", "selected": false},
            {"code": "TXM", "name": "Taxes missing information", "selected": false}
        ];
        this.$.nrChoice = [
            {"code": "NRN", "name": "New", "selected": false},
            {"code": "NRR", "name": "Returning", "selected": false}
        ];
        this.EmailBlastService.newEmail();
        this.updateFilter();
    },
    updateFilter: function(type, value, code)
    {
        if (value==0)
            code="";
        var lya = this.EmailBlastService.email.LYA; 
        if (this.$.filters.tax==0 && this.$.filters.bin==0 && this.$.filters.nrChoice==0)
            this.$.recipients = [];
        
        if (type==0 && value==1)
            this.$.filters.bin++;
        else if (type==0 && value==0)
            this.$.filters.bin--;
        else if (type==1 && value==1)
            this.$.filters.tax++;
        else if (type==1 && value==0)
            this.$.filters.tax--;
        else if (type==2 && value==1)
            this.$.filters.nrChoice++;
        else if (type==2 && value==0)
            this.$.filters.nrChoice--;

        //set categories in emailblastservice
        this.EmailBlastService.email.sentGroup = [];
        for (var cat in this.$.bin) {
            if (this.$.bin[cat].selected)
                this.EmailBlastService.email.sentGroup.push(this.$.bin[cat].code);
        }
        for (var cat in this.$.nrChoice) {
            if (this.$.nrChoice[cat].selected)
                this.EmailBlastService.email.sentGroup.push(this.$.nrChoice[cat].code);
        }
        for (var cat in this.$.status) {
            if (this.$.status[cat].selected)
                this.EmailBlastService.email.sentGroup.push(this.$.status[cat].code);
        }
        if (this.EmailBlastService.email.sentGroup.length===0)
            this.EmailBlastService.email.sentGroup.push("ALL");

        var list = [];

        if (this.EmailBlastService.email.copyMe) { //add administrator to email list
            let email = this.authServiceFactory.getAuth().userEmail;
            let id = this.authServiceFactory.getAuth().recordID;
            let name = this.authServiceFactory.getAuth().firstName + " " + this.authServiceFactory.getAuth().lastName;
            let item = {
                "Fam_Names": [name],
                "email": email, 
                "familyID": id,
                "send": 1,
                "App_Names": [0], 
                "admin": true
            };
            list.push(item);
        }

        for (var i = 0; i < this.EmailBlastRecipientsModelService.get().length; i++) { 
            var item = this.EmailBlastRecipientsModelService.get()[i];
            if ((lya && item.App_Fin_Year != this.currentYear) || (!lya && item.App_Fin_Year == this.currentYear)) { 
            // want lya and app is from last year or don't want lya and app is from current year
                var binAdd=false, statusAdd=false, nrChoiceAdd=false, catAdd=false;
                if ( this.$.filters.bin===0 ) { // bin filter is not set
                    binAdd = true;
                }
                else { // bin filter is set
                    binAdd |= this.$.bin[0].selected && this.$.inGroup( item,  "Status_New", 1);
                    binAdd |= this.$.bin[1].selected && this.$.inGroup( item,  "Status_Viewed", 1);
                    binAdd |= this.$.bin[2].selected && this.$.inGroup( item,  "Status_Consider", 1);
                    binAdd |= this.$.bin[3].selected && (this.$.inGroup( item,  "Status_Award", 1) && item.ActAward>0);
                    binAdd |= this.$.bin[4].selected && (this.$.inGroup( item,  "Status_Reject", 1) 
                        || this.$.inGroup( item,  "Status_Reject_Auto", 1)
                        || (!this.$.inGroup( item,  "Status_Award", 1) && !item.ActAward));
                }
                if ( this.$.filters.tax===0 ) { // tax status filter is not set
                    statusAdd = true;
                }
                else { // tax status filter is set
                    statusAdd |= this.$.status[0].selected && this.$.inGroup(item, "taxStatusClass", "not-received");
                    statusAdd |= this.$.status[1].selected && this.$.inGroup(item, "taxStatusClass", "missing-information");
                }
                if ( this.$.filters.nrChoice===0 ) { // new/returning filter is not set
                    nrChoiceAdd = true;
                }
                else { // new/returning filter is set
                    nrChoiceAdd |= this.$.nrChoice[0].selected && this.$.inGroup( item,  "NR_Choice", 1);
                    nrChoiceAdd |= this.$.nrChoice[1].selected && this.$.inGroup( item,  "NR_Choice", 2);
                }
                if (this.inCat(item, this.$.EmailBlastService.email.sentSubGroup) || this.$.EmailBlastService.email.sentSubGroup==="All") {
                    catAdd = true;
                }

                if (binAdd && statusAdd && nrChoiceAdd && catAdd)
                    list.push(item);
            }
        }
        this.$.recipients = list;

    },
    selectedRecipients: function()
    {
        var recipients = [];
        for (var i = 0; i < this.$.recipients.length; i++)
        {
            var recipient = this.$.recipients[i];
            if (recipient.send == "1")
                recipients.push({familyID: recipient.familyID, email: recipient.email});
        }
        return recipients;
    },
    allChecked: function()
    {
        return this.selectedRecipients().length == this.$.recipients.length;
    },
    checkEm: function(checked)
    {
        for (var i = 0; i < this.$.recipients.length; i++) {
            if (!this.$.recipients[i].admin)
                this.$.recipients[i].send = checked;
        }
    },
    inGroup: function(item, field, value)
    {
        if (value == "ALL")
            return true;
        else if (item[field] == value)
            return true;
        return false;
    },
    notInGroup: function(item, field, value)
    {
        if (item[field] != value)
            return true;
        return false;
    },
    inCat: function(item, value)
    {
        if (value == "ALL")
            return true;
        else
        {
            for (var i = 0; i < item.SubCats.length; i++) {
                if (item.SubCats[i] == value)
                    return true;
            }
            return false;
        }
    },
    reviewRecipients: function()
    {
        this.$.reviewOpen = true;
    },
    setEmail: function(item)
    {
        this.EmailBlastService.email = item;
    },
    initArchiveModal: function()
    {
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/email/partials/archiveModal.html?v=" + versionNo,
            controller: "EmailArchiveModalController",
            size: "lg"
        });
    },
    initPreviewModal: function()
    {
        this.EmailBlastService.setRecipientList(this.selectedRecipients());
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/email/partials/previewModal.html?v=" + versionNo,
            controller: "EmailPreviewModalController",
            size: "lg"
        }).result.then(
            () => {
                this.$state.reload();
                this.EmailBlastService.newEmail();
            }, // Success
            () => {
                this.updateFilter();
            } // Dismiss
        );
    }
});

angular.module("emailBlast").service("EmailBlastService", function(authServiceFactory) {
    this.newEmail = function() {
        this.email = {
            message: "",
            from: authServiceFactory.getAuth().firstName + " " + authServiceFactory.getAuth().lastName,
            fromAddress: "noreply@ismfast.com",
            replyTo: "",
            replyToAddress: "noreply@ismfast.com",
            subjectLine: "",
            sentGroup: ["ALL"],
            sentSubGroup: "ALL",
            LYA: 0
        };
    };

    this.setEmail = function(item) {
        item.sentGroup = item.sentGroup.split(",");
        this.email = item;
    };

    this.getRecipientList = function() {
        return this.recipientList;
    };

    this.setRecipientList = function(list) {
        this.recipientList = list;
    };

    this.groups = {
        TXN: {name: "Taxes not received"},
        TXM: {name: "Taxes missing information"},
        NEW: {name: "New"},
        VIE: {name: "Viewed"},
        CON: {name: "Considering"},
        AWA: {name: "Awarded"},
        REJ: {name: "Rejected"},
        ALL: {name: "All"}
    };

    this.newEmail();
});
